const _ = require('lodash'), bannerClickAnalyticsMapper = require('./atmmapper/banner-click-mapper');
const atmInternalCampaignMapper = require('../../../common/components/analytics/atm-mapper-internal-campaign');
const { getModuleIndex } = require('../../../common/components/analytics/analytics-utils');
const { EVENT_TYPE } = require('../../../common/components/analytics/constants');

module.exports = function (trolleyService, shelfProductService, dynamicContentService, dynamicContentCarouselService, inspirationService, atm, $location, $sce, $compile, $timeout, $rootScope, breakpointsService, carouselConfig) {
    return {
        restrict: 'AE',
        scope: {
            scheduleKey: '=?',
            onload: '&?',
            forceSmallFormatView: '=?',
            smallFormatStampSize: '=?'
        },
        controllerAs: 'dcCtrl',
        controller: [
            '$q', '$scope', function ($q, $scope) {
                let serverItemRequests = {};

                this.getServerItem = function (id, type) {
                    /// <summary>
                    /// Request an item from the server. Will be resolved once all items have been requested
                    /// for the layout.
                    /// </summary>
                    if (!(type in serverItemRequests)) {
                        serverItemRequests[type] = {};
                    }
                    const requestsForType = serverItemRequests[type];
                    if (!(id in requestsForType)) {
                        requestsForType[id] = $q.defer();
                    }

                    return requestsForType[id].promise;
                };

                function getRequestIds(requests) {
                    return _.reduce(requests, function (result, itemRequests, itemType) {
                        result[itemType] = _.keys(itemRequests);
                        return result;
                    }, {});
                }

                function resolveServerItemPromises(serverItems) {
                    _.forEach(serverItems, function (items, type) {
                        _.forEach(items, function (item) {
                            const idKey = type === 'Products' ? 'Stockcode' : 'ID';
                            serverItemRequests[type][item[idKey]].resolve(item);
                        });
                    });
                }

                this.onLoad = function () {
                    this.getServerItems().then(() => {
                            if ($scope.onload) {
                                $scope.onload();
                            }
                            $scope.toggleIsEmpty();
                            $scope.initCarousel();
                            if (!$('#medallia-homepage-survey').length) {
                                $("#7 .dynamic-content2-item-productgroupcarousel:eq(1)").append("<div class='container' id='medallia-homepage-survey'></div>");
                            }
                    });
                };

                this.getServerItems = function () {
                    /// <summary>
                    /// Load all of the items which have been requested for the layout.
                    /// </summary>
                    if (!_.some(serverItemRequests)) {
                        return $q(function (resolve) { resolve(); });
                    }

                    return dynamicContentService.getServerItems(getRequestIds(serverItemRequests))
                        .then(resolveServerItemPromises)
                        .finally(function () {
                            serverItemRequests = {};
                        });
                };

                this.scheduleKey = function (scheduleKey) {
                    if (scheduleKey !== undefined) {
                        $scope.scheduleKey = scheduleKey;
                    }

                    return $scope.scheduleKey;
                };
            }
        ],
        link(scope, element, attrs, ctrl) {

            const $elem = $(element);
            let paramsCache = {};
            const selector = '.dynamic-content2-panel';

            function render(data) {

                let html;
                let trustedHtml;

                if (data) {
                    data = data.replace(/<img\s/g, '<img loading="lazy" ');
                }

                html = $sce.trustAsHtml(data);
                trustedHtml = $sce.getTrustedHtml(html);
                $compile(trustedHtml)(scope, (compiled) => {
                    element.find(selector).html(compiled);

                    $(selector, element).on('click', 'dynamic-content-data a', scope.trackClick);
                    $(selector, element).on('click', '.proposition--banner a', scope.trackCvpClick);
                    $(selector, element).on('click', '.carousel-inner a', scope.trackBannerClick);
                    $(selector, element).on('click', '.hp-banner-nopadding a', scope.trackCatalogueClick);
                    $(selector, element).on('click', 'bws-explore-categories div', scope.trackExploreCategoriesClick)
                    $timeout(function () {
                        ctrl.onLoad();
                        $elem.css('display', 'block');
                    });
                });
            }

            function getContent(params) {
                const cache = dynamicContentService.getCachedContent(params.scheduleKey);
                if (!_.isUndefined(cache)) {

                    render(cache);

                } else {

                    //Make API call to get content
                    dynamicContentService.getContent(params)
                        .then((html) => {

                            const content = {
                                html,
                                id: params.scheduleKey
                            };

                            dynamicContentService.cacheContent(content);

                            render(html);

                        });
                }

            }
            /**
             * Get the dynamic content from the server and cache in a service
             * @param params is an object with a value equal to the url and
             *        placement of DC e.g { scheduleKey: /-bottom }
             * @returns {null}
             */
            function getTemplatetHtml(params) {
                $elem.css('display', 'none');
                return params.scheduleKey === null
                    ? null
                    : getContent(params);
            }

            //the below is set as a standard for dynamic content team to use the service to get browser window widths
            // the team uses as: ng-if="breakpoints.isInMediumFormat || breakpoints.isInLargeFormat" or ng-if="breakpoints.isInSmallFormat"
            scope.breakpoints = breakpointsService;
            scope.slickConfig = carouselConfig;

            scope.$watch('scheduleKey', function (scheduleKey) {
                paramsCache = { scheduleKey, v: dynamicContentService.scheduleVersion };
                getTemplatetHtml(paramsCache);
            });

            scope.addItemToTrolley = function (stockcode, quantity, source, itemId) {
                inspirationService.setDynamicContentCardIdSessionStorage(itemId);

                shelfProductService.getProductDetail(stockcode).then(function (product) {
                    if (product !== null) {
                        scope.addOrUpdateItemToTrolley(product, quantity, source);
                    }
                });
                dynamicContentService.postMetricsClick(itemId);
            };

            scope.addOrUpdateItemToTrolley = function (product, quantity, source) {
                // Check item is in trolley. If it's update quantity.
                const area = 'Dynamic content';
                if (product.IsInTrolley) {
                    const addQuantity = product.QuantityInTrolley + quantity;
                    trolleyService.updateTrolleyItem(product, addQuantity, area);
                } else {
                    trolleyService.addItemToTrolley(product, quantity, source, area);
                }
            };

            scope.addMultiItemsToTrolley = function (stockcodes, source, itemId) {
                inspirationService.setDynamicContentCardIdSessionStorage(itemId);

                shelfProductService.getProductDetail(stockcodes).then(function (products) {
                    if (products !== null) {
                        trolleyService.addItemsToTrolley(products);
                    }
                });
                dynamicContentService.postMetricsClick(itemId);
            };

            scope.toggleIsEmpty = function () {
                const visibleItems = element.find('.dynamic-content2-item:visible');
                element.find('.dynamic-content-canvas')
                    .first()
                    .toggleClass('is-empty', visibleItems.length === 0);
            };

            scope.initCarousel = function () {
                dynamicContentCarouselService.init();
                setTimeout(function () {
                    dynamicContentCarouselService.smallFormatHomeCarouselHeight = dynamicContentCarouselService.getSmallFormatHomeCarouselHeight();
                }, 10);
            };

            scope.postMetricsClick = function (itemId, name) {
                dynamicContentService.postMetricsClick(itemId);
                atm.push({ id: itemId, name, location: $location.path() }, bannerClickAnalyticsMapper);
            };

            scope.trackClick = (event) => {
                const $target = $(event.currentTarget);
                const $dynamicContentData = $target.closest('dynamic-content-data');
                const carouselName = $dynamicContentData.find('.title-container h2').text();
                const carouselItemName = $target.closest('.card-list-item').find('h3').text();
                const carouselItemIndex = parseInt($target.closest('.slick-slide').attr('data-slick-index'), 10);
                if (isNaN(carouselItemIndex) && $dynamicContentData.data('campaignname') && !$dynamicContentData.data('campaignname').includes('mixin-hp-hh')) {
                    return;
                }

                const carouselItemPosition = carouselItemIndex + 1;
                const moduleIndex = getModuleIndex($target);

                if (moduleIndex === -1) {
                    return;
                }

                const modulePlace = moduleIndex + 1;

                if ($dynamicContentData.data('campaignname') && $dynamicContentData.data('campaignname').includes('mixin-hp-hh')) {
                    atm.push({
                            type: EVENT_TYPE,
                            campaignName: $dynamicContentData.attr('data-campaignname'),
                            place: modulePlace,
                            position: 1
                        },
                        atmInternalCampaignMapper);
                }
                else {
                    atm.push(
                        {
                            type: carouselName,
                            campaignName: carouselItemName,
                            place: modulePlace,
                            position: carouselItemPosition
                        },
                        atmInternalCampaignMapper
                    );
                }

            };

            scope.trackCvpClick = (event) => {
                const $target = $(event.currentTarget);
                const $row = $target.closest('.row');
                const $cvp = $row.children().index($target.closest('div'));
                const moduleIndex = getModuleIndex($target);
                if (moduleIndex === -1) {
                    return;
                }
                const modulePlace = moduleIndex + 1;
                atm.push({
                        type: 'value proposition',
                        campaignName: $target.find('.service-title').text(),
                        place: modulePlace,
                        position: $cvp + 1
                    },
                    atmInternalCampaignMapper);
                
             };

            scope.trackBannerClick = (event) => { 
                const $target = $(event.currentTarget);
                const $dynamicContentData = $target.closest('dynamic-content-data');
                const $row = $dynamicContentData.closest('.row');
                const moduleIndex = getModuleIndex($target);
                if (moduleIndex === -1) {
                    return;
                }
                const modulePlace = moduleIndex + 1;
                atm.push({
                        type: 'hero banner',
                        campaignName: $dynamicContentData.attr('data-campaignname'),
                        place: modulePlace,
                        position: $row.find('dynamic-content-data').index($dynamicContentData) + 1
                    },
                    atmInternalCampaignMapper);
            };

            scope.trackCatalogueClick = (event) => {
                const $target = $(event.currentTarget);
                const $dynamiContentData = $target.closest('dynamic-content-data');
                const moduleIndex = getModuleIndex($target);
                if (moduleIndex === -1) {
                    return;
                }
                const modulePlace = moduleIndex + 1;
                atm.push({
                        type: 'catalogue banner',
                        campaignName: $dynamiContentData.attr('data-campaignname'),
                        place: modulePlace,
                        position: 'banner click'
                    },
                    atmInternalCampaignMapper);
            }

            scope.trackExploreCategoriesClick = (event) => {
                const $target = $(event.currentTarget);
                const moduleIndex = getModuleIndex($target);
                const pos = $target.closest('ul').children().index($target.closest('li'));
                if (moduleIndex === -1) {
                    return;
                }
                const modulePlace = moduleIndex + 2;
                atm.push({
                        type: 'explore categories',
                        campaignName: $target.find('.explore_category__category-name').text(),
                        place: modulePlace,
                        position: pos + 1
                    },
                    atmInternalCampaignMapper);
            }

            scope.setDynamicContentCardId = function (cardId) {
                inspirationService.setDynamicContentCardIdSessionStorage(cardId);
            };

            scope.$on('window:resize', scope.toggleIsEmpty);
            
            // scope.$on('store:update', () => {
            //     // Get new content when store updates, but not on page load since we already have it
            //     if (!isFirstLoad && !_.isEmpty(paramsCache)) {
            //         getTemplatetHtml(paramsCache);
            //     }
            //     isFirstLoad = false;
            // });
        },
        template: '<div class="dynamic-content2-panel"></div>'
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/dynamic-content-directive.js
 **/